<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    loading?: boolean
  }>(),
  {
    loading: true,
  },
)

const slots = defineSlots<{
  default?: () => void
}>()
</script>

<template>
  <div
    v-if="props.loading"
    data-slot="skeleton"
    :class="cn('animate-pulse rounded-full bg-disabled/30', slots.default && 'w-fit', props.class)"
  >
    <div v-if="slots.default" class="invisible flex">
      <slot />
    </div>
  </div>
  <slot v-else />
</template>
